/**
 * Enum representing the possible operators used to compare different values for vital signs and lab results.
 */
export enum ChronicObstructivePulmonaryDiseaseClassifications {
    MildForcedExpiratoryVolumeInOneSecond = "MildForcedExpiratoryVolumeInOneSecond",
    ModerateForcedExpiratoryVolumeInOneSecond = "ModerateForcedExpiratoryVolumeInOneSecond",
    SevereForcedExpiratoryVolumeInOneSecond = "SevereForcedExpiratoryVolumeInOneSecond",
    VerySevereForcedExpiratoryVolumeInOneSecond = "VerySevereForcedExpiratoryVolumeInOneSecond"
}
